import { getCountryCode, getUCI } from '@/models';
import { BK_SEPARATOR } from '@/api/hco/constants';
import { AppRoutes } from './constants';
import { CountryCode } from './countryUtils';
import { toStringOrNull } from './cube';

export const generateGoogleMapsLink = (address: string): string =>
  `https://www.google.com/maps?q=${encodeURIComponent(address)}`;

export const buildHcoBk = (
  countryCode: string | null | undefined,
  id: string | null | undefined,
): string | undefined => {
  const trimmedCountryCode = countryCode?.trim();
  const trimmedId = id?.trim();
  if (!trimmedCountryCode || !trimmedId) return undefined;
  return `${trimmedCountryCode}${BK_SEPARATOR}${trimmedId}`;
};

export const getHcoOverviewLink = (hcoBk: string, countryCode: string): string | null => {
  const _countryCode = toStringOrNull(countryCode);
  if (!_countryCode) return null;
  const _hcoBk = toStringOrNull(hcoBk);
  if (!_hcoBk) return null;
  const sourceSystemOrCountryCode = getCountryCode(_hcoBk);
  const uciOrMdmId = getUCI(_hcoBk);
  const normalizedCountry = _countryCode.trim().toUpperCase();
  if (normalizedCountry === CountryCode.RUSSIA) {
    return AppRoutes.HCO_OVERVIEW.replace(':countryCode', CountryCode.RUSSIA).replace(
      ':id',
      encodeURIComponent(uciOrMdmId),
    );
  }

  return AppRoutes.HCO_OVERVIEW.replace(':countryCode', encodeURIComponent(sourceSystemOrCountryCode)).replace(
    ':id',
    encodeURIComponent(uciOrMdmId),
  );
};

export function buildHcoLink(hcoBk: string): string | undefined {
  if (!hcoBk || !hcoBk.includes(BK_SEPARATOR)) return undefined;

  const countryCode = getCountryCode(hcoBk);
  return getHcoOverviewLink(hcoBk, countryCode) ?? undefined;
}
